import { PartnerModel } from '../../user/modal/partner-model';

export class PartyTypeModal {
  id: number;
  label: String;
  key: String;
  description: String;
  is_deleted: Boolean;
  Partner: PartnerModel;
}
